if (!customElements.get('video-hero')) {
  customElements.define('video-hero', class VideoHero extends HTMLElement {
    constructor() {
      super();
      this.media = this.dataset.videoHeroScreen;
      this.player = null;

      const controls = `
      <div class="plyr__controls-wrapper">
        <div class="plyr__controls">
          <div class="plyr__play">
          <button type="button" class="plyr__control plyr__control--overlaid" data-plyr="play" aria-pressed="false" aria-label="Play">
            <svg class="icon-play" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 16.6446V1.33403C1 1.18289 1.16121 1.08636 1.29444 1.15774L14.6912 8.33456C14.8277 8.40768 14.8329 8.60147 14.7005 8.68182L1.3038 16.8156C1.17051 16.8965 1 16.8005 1 16.6446Z" stroke="#F6F2ED" stroke-width="1.5"/>
            </svg>
            <svg class="icon-pause" width="9"  fill="none"  height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 18"><defs><style>.b{fill:none;stroke:#f6f2ed;stroke-width:1.5px;}</style></defs><path class="b" d="m.75,16.26V.95c0-.15,0-.25,0-.18v15.66c0,.08,0-.02,0-.17Z"/><path class="b" d="m6.7,16.26V.95c0-.15,0-.25,0-.18v15.66c0,.08,0-.02,0-.17Z"/></svg>
          </button>
          </div>
          <div class="plyr__progress">
            <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
            <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
            <span role="tooltip" class="plyr__tooltip">00:00</span>
            <div class="plyr__time-wrapper">
              <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
              <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
            </div>
          </div>
          <div class="plyr__volume-wrapper" tabindex="0">
            <div class="plyr__volume-icon">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5352 2.17444V0C15.7403 0.960555 18.8758 4.73944 18.8758 9.25722C18.8758 13.775 15.7403 17.5539 11.5352 18.5144V16.34C14.5658 15.4322 16.7785 12.6033 16.7785 9.25722C16.7785 5.91111 14.5658 3.08222 11.5352 2.17444ZM0 6.09056V12.4239H4.19463L9.43791 17.7017V0.812781L4.19463 6.09056H0ZM14.1569 9.25723C14.1569 7.38889 13.0872 5.78445 11.5352 5.00334V13.5006C13.0872 12.73 14.1569 11.1256 14.1569 9.25723Z" fill="#F6F2ED"/>
              </svg>
            </div>
            <div class="plyr__volume">
                <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
                <span class="plyr__volume--item plyr__volume--curent"></span>
                <div class="plyr__volume--item plyr__volume--total">
                  <div></div>
                </div>
            </div>
          </div>
        </div>
      </div>
      `;

      document.addEventListener('DOMContentLoaded', () => {
        const videoVimeo = this.querySelector('.js-video-vimeo');
        const isDesktop = window.matchMedia('(min-width: 750px)');
        const autoplay = this.media === 'desktop' && isDesktop || this.media === 'mobile' && !isDesktop;

        this.player = new Plyr(videoVimeo, {
          autoplay,
          autopause: false,
          muted: false,
          vimeo: {
            background: 1,
            transparent: 0,
          },
          controls: controls
        });

        const player = this.player;

        this.player.on('timeupdate', (event) => {
          const element = this.querySelector('.plyr__progress input[data-plyr="seek"]');
          const value = element.style.getPropertyValue("--value");
          const currentValue = element.getAttribute('aria-valuenow');
          this.querySelector('.plyr__time--current').style.width = value;
          this.querySelector('.plyr__time--duration').setAttribute('aria-valuenow', currentValue);
        })

        this.player.on('volumechange', (event) => {
          const element = this.querySelector('.plyr__volume input[data-plyr="volume"]');
          const value = element.style.getPropertyValue("--value");
          this.querySelector('.plyr__volume--curent').style.width = value;

          if(player.volume > 0) {
            this.querySelector('.plyr__volume-icon').classList.add('plyr__volume--set-up');
          } else {
            if( this.querySelector('.plyr__volume-icon').classList.contains('plyr__volume--set-up') ) {
              this.querySelector('.plyr__volume-icon').classList.remove('plyr__volume--set-up');
            }
          }

        });

        this.player.on('ready', (event) => {
          player.volume = 0;
          const volumeIcon = this.querySelector('.plyr__volume-icon');
          volumeIcon.addEventListener('click', () => {
            volumeIcon.classList.toggle('plyr__volume--set-up');
            if( volumeIcon.classList.contains('plyr__volume--set-up') ) {
              player.volume = 1;
            } else {
              player.volume = 0;
            }
          });

          const elementProgress = this.querySelector('.plyr__progress input[data-plyr="seek"]');
          const volumeWrapper = this.querySelector('.plyr__volume-wrapper');
          const volumeElement = this.querySelector('.plyr__volume input[data-plyr="volume"]');
          this.addEventListener('focusin', () => {
            if(elementProgress === this.activeElement && this.body.classList.contains('using-tab')) {
              elementProgress.parentNode.classList.add('is-focused');
            } else {
              elementProgress.parentNode.classList.remove('is-focused');
            }

            if(volumeWrapper === this.activeElement && this.body.classList.contains('using-tab')) {
              volumeWrapper.classList.add('is-focused');
            } else if(volumeElement ===  this.activeElement && this.body.classList.contains('using-tab')) {
              volumeWrapper.classList.remove('is-focused');
              volumeWrapper.classList.add('was-focused');
              volumeElement.parentNode.classList.add('is-focused');
            } else {
              volumeWrapper.classList.remove('is-focused', 'was-focused');
              volumeElement.parentNode.classList.remove('is-focused');
            }
          });
        });

      });

      window.addEventListener('resize', () => {
        this.player.volume = 0;
      });
    };
  });
}
